import IEnum from '../interfaces/IEnum';

export const StepGroupTypes: IEnum = {
    translations:{
        0: {
            name: 'lang.inscriptions.myPersonalDataWizard'
        },
        1: {
            name: 'lang.inscriptions.legalConditionsWizard',
        },
        2: {
            name: 'lang.inscriptions.requirementsWizard',
        },
        3: {
            name: 'lang.shared.merits',
        },
        4: {
            name: 'lang.inscriptions.payWizard',
        },
        5: {
            name: 'lang.shared.exams',
        }
    },
    enum:{
        MYPERSONALDATAWIZARD: 0,
        LEGALCONDITIONSWIZARD: 1,
        REQUIREMENTSWIZARD: 2,
        MERITS: 3,
        PAYWIZARD: 4,
        CREDITABLEEXAMS: 5
    }
};
